import { createSlice } from "@reduxjs/toolkit";
// utils
import { PATH_DASHBOARD } from "../../routes/paths";
import axios from "../../utils/axios";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  update: false,
  keyPersons: [],
  fetchLoading: false,
  singleKeyPerson: null,
};

const slice = createSlice({
  name: "keyPersons",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // START LOADING
    fetchLoading(state) {
      state.fetchLoading = true;
    },
    // UPDATE EVENT
    updateKeyPersonSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      // state.keyPersons = state.keyPersons.map((keyPerson) => {
      //   if (keyPerson.id === action.payload.id) {
      //     return action.payload;
      //   }
      //   return keyPerson;
      // });
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.update = false;
      state.error = action.payload;
    },

    // GET PRODUCTS
    getKeyPersonSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.keyPersons = action.payload;
    },

    // GET SINGLE SUCCESS
    getSingleKeyPersonSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.singleKeyPerson = action.payload;
    },

    // GET PRODUCTS
    createKeyPersonSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.keyPersons = [...state.keyPersons, action.payload];
    },

    // DELETE EVENT
    deleteKeyPersonSuccess(state, action) {
      const keyPersonId = action.payload;
      state.keyPersons = state.keyPersons.filter(
        (keyPerson) => keyPerson.id !== keyPersonId
      );
      state.isLoading = false;
      state.fetchLoading = false;
    },
  },
});

export default slice.reducer;

export function getKeyPersons() {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get("key-persons");
      dispatch(slice.actions.getKeyPersonSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSingleKeyPerson({ id }) {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get(`key-persons/${id}`);
      dispatch(slice.actions.getSingleKeyPersonSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createKeyPerson({ data, enqueueSnackbar, navigate }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post("key-persons", data);
      dispatch(slice.actions.createKeyPersonSuccess(response.data.data));
      enqueueSnackbar("Key Person is added successfully");
      navigate(PATH_DASHBOARD.settings.keypersons.list);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateKeyPerson({ id, data, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`key-persons/${id}`, data);
      dispatch(slice.actions.updateKeyPersonSuccess(response.data.data));
      enqueueSnackbar("Key Person is updated successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteKeyPerson({ id, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`key-persons/${id}`);
      dispatch(slice.actions.deleteKeyPersonSuccess(id));
      enqueueSnackbar("Key Person is deleted successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
